/**
 * DIEUKYDIEU.TV - WINDOW GLOBALS COMPATIBILITY BINDINGS
 * Exposes methods to global window for HTML onclicks, inline handlers & automated testing.
 */
export function registerWindowGlobals(g) {
    if (typeof window === 'undefined') return;
    Object.assign(window, g);

    // Sidebar & Navigation Helpers
    window.openSidebarCategory = function(slug, subId = null) {
        if (typeof window.openCategoryBySlug === 'function') {
            window.openCategoryBySlug(slug, true);
        }
        if (subId) {
            const targetChip = document.querySelector(`#cat-tier1-chips .chip[data-child-id="${subId}"]`);
            if (targetChip) {
                targetChip.click();
            } else if (typeof window.onSelectTier1 === 'function') {
                window.onSelectTier1(subId);
            }
        }
        if (typeof window.updateSidebarActive === 'function') {
            window.updateSidebarActive('category-detail-view', slug, null, null, subId);
        }
        if (typeof window.closeMobileSidebar === 'function') {
            window.closeMobileSidebar();
        }
    };

    window.openSidebarMedia = function(tier1, subCat = 'all') {
        if (typeof window.switchNav === 'function') {
            window.switchNav('media-view', 2);
        }
        if (typeof window.filterMedia === 'function') {
            window.filterMedia(tier1, null, subCat);
        }
        if (typeof window.updateSidebarActive === 'function') {
            window.updateSidebarActive('media-view', null, tier1, subCat);
        }
        if (typeof window.closeMobileSidebar === 'function') {
            window.closeMobileSidebar();
        }
    };

    window.scrollToExploreNetwork = function() {
        if (typeof window.switchNav === 'function') window.switchNav('category-view', 1);
        if (typeof window.updateSidebarActive === 'function') {
            window.updateSidebarActive('links');
        }
        if (typeof window.closeMobileSidebar === 'function') {
            window.closeMobileSidebar();
        }
        setTimeout(() => {
            const el = document.getElementById('explore-network-section');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
    };

    window.openTopicQuizFromNav = function() {
        if (typeof window.openTopicQuiz === 'function' && Array.isArray(window.CAROUSEL_TOPICS) && window.CAROUSEL_TOPICS.length > 0) {
            window.openTopicQuiz(window.CAROUSEL_TOPICS[0]);
        }
    };

    window.toggleSidebarLangMenu = function(e) {
        if (e) e.stopPropagation();
        const menu = document.getElementById('sidebar-lang-menu');
        const backdrop = document.getElementById('sidebar-lang-backdrop');
        if (menu) {
            const isShown = menu.classList.toggle('show');
            if (backdrop) backdrop.classList.toggle('show', isShown);
        }
    };

    window.goToMasterBanner = function(idx) {
        if (typeof g.goToMasterBanner === 'function') g.goToMasterBanner(idx);
    };

    window.nextMasterBanner = function(e) {
        if (typeof g.nextMasterBanner === 'function') g.nextMasterBanner(e);
    };

    window.prevMasterBanner = function(e) {
        if (typeof g.prevMasterBanner === 'function') g.prevMasterBanner(e);
    };
}
